import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";
import { formatNullable } from "../../../../../../common/src/util/dataUtil";
import config from "../../../../../../server/src/config";

import * as AdminActions from "../../../../actions/admin";

export const defaultState = {
    Formand: '',
    Kasserer: '',
    Loeslader: '',
    Edb: '',
};

class SectionContacts extends React.Component {

    static propTypes = {
        editMode: PropTypes.bool,
        section: PropTypes.object,
    }

    static defaultProps = {
        editMode: false,
    };

    constructor(props) {
        super(props);
        this.state = Object.assign({}, this.getStateFromStore(props));
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.editMode || ((nextProps.section === null && this.props.section !== null) || (nextProps.section !== null && (this.props.section === null || this.props.section.Foreningsnr !== nextProps.section.Foreningsnr)))) this.setState(this.getStateFromStore(nextProps));
    }

    getStateFromStore(props) {
        if (props.section === null)
            return defaultState;
        else {
            const section = props.section;
            return {
                Formand: section.Formand === null ? '' : section.Formand,
                Kasserer: section.Kasserer === null ? '' : section.Kasserer,
                Loeslader: section.Loeslader === null ? '' : section.Loeslader,
                Edb: section.Edb === null ? '' : section.Edb,
            }
        }
    }

    fields = [];
    render() {

        const getContactInfo = memberNo => {
            const member = this.props.admin.members.get(memberNo) || null;
            const city = member === null || member.Postnr === null ? null : this.props.admin.zipCodes.get(member.Postnr) || null;
            return [
                <td key="address" style={{width: "50%"}}>
                    <div className="address-container">
                        {[
                            member === null || (member.Fornavn === null && member.Efternavn === null) ? null : <div key="line1">{formatNullable(member.Fornavn, '') + (member.Fornavn === null || member.Efternavn === null ? '' : ' ') + formatNullable(member.Efternavn, '')}</div>,
                            member === null || member.C_O_adresse === null ? null : <div key="line2">CO. {member.C_O_adresse}</div>,
                            member === null || member.Adr === null ? null : <div key="line3">{member.Adr + (member.Husnr === null && member.Husbogstav === null ? '' : ' ') + formatNullable(member.Husnr, '') + formatNullable(member.Husbogstav, '') + (member.Etage === null && member.Placering === null ? '' : ' ') + formatNullable(member.Etage, '') + formatNullable(member.Placering, '')}</div>,
                            member === null || member.Postboks === null ? null : <div key="line4">Postboks {member.Postboks}</div>,
                            member === null || member.Postnr === null ? null : <div key="line5">{member.Postnr + (city === null || city.By === null ? '' : ' ' + city.By)}</div>,
                        ]}
                    </div>
                </td>,
                <td key="contact" style={{width: "50%"}}>
                    <div className="address-container">
                        {[
                            member === null || member.Kontaktnavn === null ? null : <div key="line1">{member.Kontaktnavn}</div>,
                            member === null || member.Tlf === null ? null : <div key="line2">Tlf. <a href={'tel:' + member.Tlf} tabIndex={-1}>{member.Tlf}</a></div>,
                            member === null || member.Email === null ? null : <div key="line3">Email. <a href={'mailto:' + member.Email} tabIndex={-1}>{member.Email}</a></div>,
                        ]}
                    </div>
                </td>
            ];
        };

        const editMode = this.props.editMode;
        const formand = getContactInfo(this.state.Formand);
        const kasserer = getContactInfo(this.state.Kasserer);
        const edb = getContactInfo(this.state.Edb);
        const loeslader = getContactInfo(this.state.Loeslader);
        return <div className={"form-page club-contacts " + (editMode ? "editable" : "read-only")}>
            <table className="main-form-table">
                <tbody>
                <tr className="address-row">
                    <td className={"label-cell"}><span className="label-text"><label htmlFor="Formand">Formand</label></span></td>
                    <td className={"data-cell"}>
                        {editMode ? <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 medium-small-field" containerClassName="display-inline-block"
                                                      name="Formand" id="Formand" maxLength="6" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{6}"}]} value={this.state.Formand}
                                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                      onChange={this.onMemberNumberFieldChange}
                                                      ref={instance => { this.fields[0] = instance; }}
                        /> : <span className="value-text">{this.state.Formand}</span>}
                    </td>
                    <td>
                        <table>
                            <tbody>
                            <tr>
                                {formand}
                            </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr className="address-row">
                    <td className={"label-cell"}><span className="label-text"><label htmlFor="Kasserer">Kasserer</label></span></td>
                    <td className={"data-cell"}>
                        {editMode ? <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 medium-small-field" containerClassName="display-inline-block"
                                                      name="Kasserer" id="Kasserer" maxLength="6" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{6}"}]} value={this.state.Kasserer}
                                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                      onChange={this.onMemberNumberFieldChange}
                                                      ref={instance => { this.fields[1] = instance; }}
                        /> : <span className="value-text">{this.state.Kasserer}</span>}
                    </td>
                    <td>
                        <table>
                            <tbody>
                            <tr>
                                {kasserer}
                            </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr className="address-row">
                    <td className={"label-cell"}><span className="label-text"><label htmlFor="Edb-kontakt">Edb-kontakt</label></span></td>
                    <td className={"data-cell"}>
                        {editMode ? <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 medium-small-field" containerClassName="display-inline-block"
                                                      name="Edb" id="Edb" maxLength="6" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{6}"}]} value={this.state.Edb}
                                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                      onChange={this.onMemberNumberFieldChange}
                                                      ref={instance => { this.fields[0] = instance; }}
                        /> : <span className="value-text">{this.state.Edb}</span>}
                    </td>
                    <td>
                        <table>
                            <tbody>
                            <tr>
                                {edb}
                            </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr className="address-row">
                    <td className={"label-cell"}><span className="label-text"><label htmlFor="Loeslader">Løslader</label></span></td>
                    <td className={"data-cell"}>
                        {editMode ? <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 medium-small-field" containerClassName="display-inline-block"
                                                      name="Loeslader" id="Loeslader" maxLength="6" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{6}"}]} value={this.state.Loeslader}
                                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                      onChange={this.onMemberNumberFieldChange}
                                                      ref={instance => { this.fields[3] = instance; }}
                        /> : <span className="value-text">{this.state.Loeslader}</span>}
                    </td>
                    <td>
                        <table>
                            <tbody>
                            <tr>
                                {loeslader}
                            </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    }

    onMemberNumberFieldChange = (e) => {
        if (e.target.value.length === 6) {
            const member = this.props.admin.members.get(e.target.value) || null;
            if (member === null) this.props.dispatch(AdminActions.getMember(e.target.value));
        }
        this.onStandardFieldChange(e);
    };

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    save = (onSuccess = null) => {
        if (this.allInputValid()) {
            const entity = {
                Formand: this.state.Formand === '' ? null : this.state.Formand,
                Kasserer: this.state.Kasserer === '' ? null : this.state.Kasserer,
                Edb: this.state.Edb === '' ? null : this.state.Edb,
                Loeslader: this.state.Loeslader === '' ? null : this.state.Loeslader,
            };
            if (this.props.section === null) this.props.dispatch(AdminActions.createSection(entity, onSuccess));
            else this.props.dispatch(AdminActions.updateSection(this.props.section.Sektionsnr, entity, onSuccess));
        } else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    }
}

const isUndefined = value => typeof(value) === "undefined";

const mapStateToProps = (state) => ({
    admin: {
        members: state.admin.members,
        zipCodes: state.admin.zipCodes,
    }
});

export default connect(mapStateToProps, null, null, {withRef: true})(SectionContacts);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/section/subPages/SectionContacts.js